class StickElementToBottom {
  constructor(options = {
    fixedParent: null, // mandatory
    staticParent: null, // mandatory
    mobileParent: null,
    scrollingElement: document.body,
    afterSwitchToMobile : () => {},
    afterSwitchToDesktop : () => {}
  }) {

    const element = options.fixedParent.querySelector('*');
    Object.assign(this, options, { element, position: 'fixed' });

    this.watchWinSize();
    this.watchScroll();

    if (this.mobileParent) {
      window.addEventListener('resize', () => this.watchWinSize());
    }
    this.scrollingElement.addEventListener('scroll', () => this.watchScroll());
  }
  appendElement(position) {
    if (this.position === "mobile") {
      return false;
    }
    if (this.position !== position) {
      this[`${position}Parent`].appendChild(this.element);
      this.position = position;
    }
  }
  watchScroll() {
    const staticElPosition = this.staticParent.getBoundingClientRect().top;
    const elementHeight = this.element.offsetHeight;
    const winHeight = this.getWinHeight();

    this.appendElement(staticElPosition - winHeight + elementHeight > 0 ?
      'fixed' : 'static');
  }
  watchWinSize() {
    const winHeight = this.getWinHeight();
    const elementHeight  = this.element.offsetHeight;
    const fixedMinHeight = On.MediaQueries.height.medium + elementHeight;

    if (winHeight < fixedMinHeight) {
      this.setStaticParentHeight('mobile');
      this.appendElement('mobile');
      this.afterSwitchToMobile();
    } else {
      this.position = 'reset';
      this.setStaticParentHeight();
      this.watchScroll();
      this.afterSwitchToDesktop();
    }
  }
  setStaticParentHeight(isMobile) {
    this.staticParent.style.height =
      `${isMobile ? 0 : this.element.offsetHeight}px`;
  }
  getWinHeight() {
    return window.innerHeight || document.documentElement.clientHeight
      || document.body.clientHeight;
  }
}

export default StickElementToBottom;



// WEBPACK FOOTER //
// ./src/assets/javascripts/StickElementToBottom.js